

export enum ESubscriptionProvider {
  IAP = "inapp_purchase",
  STRIPE = "stripe",
}
export enum ESubsctiptionGrantType {
  PURCHASED = "purchased",
  ADMIN = "admin_given",
  PARTNERSHIP = "partnership",
}